var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('authorization',{attrs:{"permissionKey":"surgery_ward_reception_queue","can":"read"}},[_c('attendances',{attrs:{"queueType":"surgery_reception","medicalRecordPath":"indicacao-cirurgica"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }